var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m20 4h-14c-1.1 0-2 0.9-2 2v5h2v-3l6.4 4.8q0.3 0.2 0.6 0.2 0.3 0 0.6-0.2l6.4-4.8v9h-8v2h8c1.1 0 2-0.9 2-2v-11c0-1.1-0.9-2-2-2zm-7 6.8l-6.3-4.8h12.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m2 12h7v2h-7zm2 3h6v2h-6zm3 3h4v2h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.dffddf72b43f60cca135a8a5d0d3a622.svg";
export { ForwardRef as ReactComponent };